import React from 'react';
import { Checkbox, Popover } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import cn from 'classnames';

import Badge from '@components/snippets/Badge';
import Color from '../../../constants/Color';

const colors = Object.keys(Color);

function ColorPicker({ popover, value = 'grey', onChange }) {
  const { t } = useTranslation();
  const activeIndex = findIndex(colors, (v) => v === value);

  const handleChange = (index) => () => {
    if (onChange) {
      onChange(colors[index]);
    }
  };

  const pickerContent = map(colors, (color, index) => (
    <Checkbox
      onClick={handleChange(index)}
      checked={activeIndex === index}
      className={cn('color-picker__item', `color-picker__item--${color}`)}
      color={color}
      size="lg"
    />
  ));

  return (
    <div
      className={cn('color-picker', {
        'color-picker--popover': popover,
      })}
    >
      {popover ? (
        <Popover
          overlayClassName="color-picker__popover"
          placement="right"
          open={true}
          content={
            <div className="color-picker__popover-content color-picker">
              {pickerContent}
            </div>
          }
        >
          <div className="color-picker__control">
            <Badge className="color-picker__control-badge" color={value} />
            <span>{t('color')}</span>
            <RightOutlined className="color-picker__control-icon" />
          </div>
        </Popover>
      ) : (
        pickerContent
      )}
    </div>
  );
}

export default ColorPicker;
